<template>
    <div>
        <div class="one-row mb20" v-on:keyup.enter="onEnterSubmit">
            <div v-for="(n, indexOf) in 6" :key="'pin-' + n">
                <input
                    :id="indexOf"
                    :ref="indexOf"
                    type="text"
                    maxlength="1"
                    v-model="pin[indexOf]"
                    @keyup="keyPressDown"
                    @focus="focusInput"
                    :autofocus="indexOf === 0"
                    autocomplete="off"
                    inputmode="numeric"
                    placeholder="#"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        android: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            pin: ['', '', '', '', '', ''],
            index: 1
        };
    },

    methods: {
        ...mapActions({
            checkPin: 'auth/checkPin'
        }),

        focusInput(e) {
            this.index = parseInt(e.target.id);
        },

        checkIfValid() {
            const pin = this.pin.join('');
            const found = pin.match('^[0-9]{6}');
            return !!found;
        },

        keyPressDown(e) {
            switch (e.key) {
                case 'Backspace':
                    this.clearInput();
                    this.$emit('pin', pin);
                    break;
                case 'ArrowDown':
                    break;
                case 'ArrowUp':
                    break;
                case 'ArrowLeft':
                    break;
                case 'ArrowRight':
                    break;
                case 'Enter':
                    break;
                default:
                    const number = parseInt(e.key);
                    if (!isNaN(number) && !this.android) {
                        this.onPress(e);
                    } else {
                        if (this.index < 5) {
                            this.index += 1;
                        }
                        if (this.index >= 0 && this.index <= 5) {
                            this.$refs[this.index][0].focus();
                        }
                    }

                    const pin = this.pin.join('');
                    this.$emit('pin', pin);

                    break;
            }
        },

        async onPress(e) {
            let el = this.$refs[this.index][0];

            if (el.value === '') {
                el.value = e.key;
                this.pin[this.index] = e.key;
            }

            if (this.index >= 0 && this.index <= 5) {
                this.$refs[this.index][0].focus();

                if (this.index < 5) {
                    this.index += 1;
                }
            }
        },

        clearInput() {
            let el = this.$refs[this.index][0];
            if (this.index >= 0 && this.index <= 5) {
                el.value = '';
                this.pin[this.index] = '';
                if (this.index > 0) {
                    this.index -= 1;
                    this.$refs[this.index][0].focus();
                }
            }
        },

        onEnterSubmit() {
            if (this.checkIfValid()) {
                this.submit();
            } else {
                this.$toast.error(this.$t('global.incorrectLoginCredentials'));
            }
        },

        async submit() {
            const pin = this.pin.join('');
            this.$emit('submit', pin);
        }
    }
};
</script>

<style scoped>
.subtitle-center {
    font-size: 18px;
    margin-bottom: 16px;
}

input {
    padding: 10px;
    border: 1px solid #ddd;
    width: 50px;
    height: 50px;
    text-align: center;
    font-size: 30px;
}

@media (max-width: 500px) {
    input {
        width: 37px;
        height: 37px;
        font-size: 16px;
    }
}

@media (max-width: 350px) {
    input {
        width: 30px;
        height: 30px;
        font-size: 16px;
    }
}
</style>
